import { render, staticRenderFns } from "./StudentSearch.vue?vue&type=template&id=766e8172&scoped=true"
import script from "./StudentSearch.vue?vue&type=script&lang=ts"
export * from "./StudentSearch.vue?vue&type=script&lang=ts"
import style0 from "./StudentSearch.vue?vue&type=style&index=0&id=766e8172&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766e8172",
  null
  
)

export default component.exports